import React from 'react';
import { Link } from 'react-router-dom';
import { FaArrowRight, FaFacebookF, FaTrain, FaRegBookmark } from 'react-icons/fa';
import { Heading, PageTitle } from '../../components';
import { kolejWaskotorowaData } from '../../constants';
import './KolejWaskotorowa.css';

const KolejWaskotorowaPage = () => {
    const { overview, manifesto, facebookUrl, breadcrumb } = kolejWaskotorowaData;

    return (
        <>
            <PageTitle
                title={breadcrumb}
                page={breadcrumb}
                heading='Krośniewice i kolejowe dziedzictwo regionu'
                subTitle={overview.intro}
            />

            <section className='kw-section kw-overview'>
                <div className='kw-container'>
                    <Heading title={overview.subtitle} subTitle='Wybierz zakładkę albo zacznij od tego, po co istnieje ta strona' sideHeading />

                    <div className='kw-overview-grid'>
                        <div className='kw-copy-box'>
                            <div className='kw-lead-icon'>
                                <FaTrain />
                            </div>
                            <p>{overview.intro}</p>

                            <div className='kw-actions'>
                                <a className='kw-button' href={facebookUrl} target='_blank' rel='noreferrer'>
                                    <FaFacebookF />
                                    Facebook towarzystwa
                                </a>
                                <Link className='kw-button secondary' to='/Kolej-Waskotorowa/Historia'>
                                    Zobacz historię
                                    <FaArrowRight />
                                </Link>
                            </div>
                        </div>

                        <div className='kw-manifest-box'>
                            <div className='kw-panel-label'>
                                <FaRegBookmark />
                                <span>{manifesto.title}</span>
                            </div>

                            <h3>{manifesto.subtitle}</h3>
                            <p>{manifesto.lead}</p>

                            <ul>
                                {manifesto.points.map((point) => (
                                    <li key={point}>{point}</li>
                                ))}
                            </ul>

                            <strong>{manifesto.closing}</strong>
                        </div>
                    </div>
                </div>
            </section>

            <section className='kw-section kw-cards'>
                <div className='kw-container'>
                    <div className='kw-card-grid'>
                        {overview.cards.map((card) => (
                            <Link key={card.id} to={card.link} className='kw-card'>
                                <h3>{card.title}</h3>
                                <p>{card.text}</p>
                                <span>
                                    Przejdź dalej <FaArrowRight />
                                </span>
                            </Link>
                        ))}
                    </div>
                </div>
            </section>
        </>
    );
};

export default KolejWaskotorowaPage;